<template>
  <CRow>
    <CCol sm="12">

      <CCard>

        <CCardHeader>
          <CIcon name="cil-window"/>
          Eine neue Leistung anlegen
        </CCardHeader>

        <CCardBody>
          <ValidationObserver v-slot="{ invalid }">
            <CForm class="no-mb" @submit.prevent="newLeistung()">

              <FreizeitText v-model="name" formLabel="Name"/>

              <FormError v-if="formError" :errormessage="formError"/>

              <CRow class="mt-4">
                <CCol col="12" class="text-right">
                  <CButton color="primary" class="px-4" :disabled="invalid" type="submit">Leistung anlegen</CButton>
                </CCol>
              </CRow>

            </CForm>
          </ValidationObserver>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import FormError from '@/components/FormError'
import FreizeitText from '@/components/FormElements/Text'

export default {
  name: 'MitarbeiterNew',
  components: {
    FormError,
    FreizeitText
  },
  data () {
    return {
      name: '',
      formError: null
    }
  },
  mounted () {
    this.setDefaults()
  },
  methods: {
    setDefaults () {
      this.name = ''
      this.formError = null
    },
    newLeistung () {
      Vue.axios.post('/leistung/post', {
        name: this.name
      }).then((response) => {
        this.$router.push({ path: '/leistungen/uebersicht' })
        this.$snotify.success('Die neue Leistung wurde angelegt.', {
          position: 'rightTop',
          timeout: 4000
        })
        this.setDefaults()
      }).catch((error) => {
        this.formError = error.response.data
      })
    }
  }
}
</script>
